import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-on-demand',
  templateUrl: './on-demand.component.html',
  styleUrls: ['./on-demand.component.scss']
})
export class OnDemandComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
